<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.configuration') }} > {{ $t('sidebar.assignskutowarehouse') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <BaseNotFoundData
        v-if="!products.length"
        :title="$t('apps.inventory.message.notfoundskus')"
        :detail="$t('apps.inventory.message.createnewproducts')"
      />
      <Section
        v-for="(item, index) of form.warehouses"
        v-else
        :key="index"
      >
        <SectionHeader :title="$t('apps.inventory.message.assignskutowarehouse', { value: item.whName })"/>
        <FormRow>
          <Col className="col-lg-12">
          <BaseNotFoundData
            v-if="!products.length"
            :title="$t('apps.inventory.message.notfoundskus')"
            :detail="$t('apps.inventory.message.createnewproducts')"
          />
          <BaseAssignSkus
            v-else
            v-model="item.assignItems"
            :items="item.items"
          />
          </Col>
        </FormRow>
      </Section>

      <BaseFormAction
        v-if="products.length"
        :textCancel="$t('button.cancel')"
        :textSubmit="$t('button.save')"
        :isSubmitted="isSubmitted"
        @onCancel="handleCancel"
        @onSubmit="handleSubmit"
      />

      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import discardFormMixin from '@/mixins/discardForm'

export default {
  mixins: [discardFormMixin],

  data () {
    return {
      loading: true,
      isSubmitted: false,
      form: {
        warehouses: [],
      },
      formOriginal: null,
    }
  },

  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      sidebar: 'getSidebar',
      products: 'getProducts',
      getProductInfoBySkuId: 'getProductInfoBySkuId',
    }),
  },

  watch: {
    warehouses () {
      sidebarModule.init(_.cloneDeep(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 9,
        submenuAtIdx: 1,
      })
    },
  },

  async created () {
    await this.fetchData()
    this.setState()
    this.formOriginal = cloneDeep(this.form)
  },

  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 10,
      },
    })
    // set sidebar stockcontrols ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.active({
      sidebarAtIdx: 9,
      submenuAtIdx: 1,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    async fetchData () {
      this.loading = true
      await Promise.all([
        this.$store.dispatch('getWarehouses'),
        this.$store.dispatch('getProducts'),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    setState () {
      const skusItems = this.products.reduce((acc, cur) => {
        const skus = cur.prices.map((price) => {
          return {
            text: this.getProductFullName(cur.product_name, price.attributes),
            value: price.sku_id,
          }
        })
        return acc.push(...skus) && acc
      }, [])
      this.form.warehouses = this.warehouses.reduce((acc, cur) => {
        acc.push({
          whId: cur.warehouse_id,
          whName: cur.warehouse_name,
          assignItems: cur.assign_skus
            .filter((sku) => {
              const productInfo = this.getProductInfoBySkuId(sku.sku_id)
              return productInfo != undefined
            })
            .map((sku) => {
              const productInfo = this.getProductInfoBySkuId(sku.sku_id)
              const skuInfo = productInfo.prices.find((price) => price.sku_id === sku.sku_id)
              const fullName = this.getProductFullName(productInfo.product_name, skuInfo.attributes)
              return {
                text: fullName,
                value: sku.sku_id,
                active: true,
              }
            }),
          items: skusItems,
        })
        return acc
      }, [])
    },
    handleCancel () {
      this.form = cloneDeep(this.formOriginal)
    },
    async handleSubmit () {
      this.isSubmitted = true
      for (const item of this.form.warehouses) {
        const dataSet = {
          'skus': item.assignItems.map((_item) => {
            return {
              'sku_id': _item.value,
            }
          }),
        }
        await this.$store.dispatch('updateWarehouseAssignSkus', { id: item.whId, data: dataSet })
      }
      this.isSubmitted = false
      this.notify(this.$vs, {
        text: this.$t('message.saved'),
        color: 'success',
        icon: 'cloud',
      })
      this.fetchData()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/inventory/configuration/AssignSku.vue